import React from "react";
import Paragraph from "./paragraph";
import List from "./list";
import Embed from "./embed";
import Quote from "./quote";
import Heading from "./heading";
import Image from "./image";
import Group from "./group";
import Table from "./table";
import Footnotes from "./footnotes";

const Test = (props) => {
  return process.env.NODE_ENV !== "production" ? (
    <pre>{JSON.stringify(props, null, 2)}</pre>
  ) : null;
};

const componentMapper = (blocks, insideGroup = false) => {
  const componentList = {
    "core/paragraph": Paragraph,
    "acf/footnotes": Footnotes,
    "core/list": List,
    "core/embed": Embed,
    "core/quote": Quote,
    "core/heading": Heading,
    "core/image": Image,
    "core/group": Group,
  };
  return blocks.map((block, index) => {
    if (Object.keys(block) === 0) {
      return null;
    }
    if (block.name === "core/table") {
      return <Table key={`table=${index}`} innerContent={block.saveContent} />;
    }
    const Component = componentList[block.name] ?? Test;
    return (
      <Component
        key={`${block.name}-${index}`}
        {...block.attributes}
        {...block.customFields}
        innerBlocks={block.innerBlocks}
        insideGroup={insideGroup}
      />
    );
  });
};

export default componentMapper;
